<template>
  <div
    class="commentaire"
    @click.stop=""
  >
    <label>
      {{ $t(`liste.commentaire.${labelKey}`) }}
      <UilInfoCircle
        v-tooltip="{
          content: collaboration
            ? $t('liste.commentaire.aide-collaborative')
            : $t('liste.commentaire.aide-commentaire'),
          theme: 'blue',
        }"
      />
    </label>
    <textarea
      v-model="value.commentaire"
      :placeholder="$t('liste.commentaire.ecrivez-votre-commentaire-ici')"
      @keydown="debounceSaveComment"
    />
    <p v-if="commentSavedState">
      <template v-if="commentSavedState === 'pending'">
        <UilSync />
        {{ $t('liste.commentaire.enregistrement-en-cours') }}
      </template>
      <template v-else-if="commentSavedState === 'error'">
        <UilTimesCircle />
        {{ $t('liste.commentaire.une-erreur-survenue-enregistrement') }}
      </template>
      <template v-else-if="commentSavedState === 'saved'">
        <UilCheckCircle />
        {{ $t("general.enregistre") }}
      </template>
    </p>
  </div>
</template>

<script>
import {
  UilSync, UilCheckCircle, UilTimesCircle, UilInfoCircle,
} from "@lde/vue-unicons";

import config from "@/config";
import Api from "@/modules/axios";

export default {
  name: "CommentaireListe",
  components: {
    UilSync,
    UilCheckCircle,
    UilTimesCircle,
    UilInfoCircle,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    typeObject: {
      type: String,
      required: true,
      validator: (value) => ["liste", "ligne_de_liste", "panier"].includes(value),
    },
    collaboration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comment: "",
      commentSavedState: "",
      debounceTimer: null,
    };
  },
  computed: {
    /**
     * Clé de traduction du libellé affiché au-dessus du commentaire.
     * @returns {String} Clé de traduction.
     */
    labelKey() {
      return {
        liste: "commentaire-sur-liste",
        panier: "commentaire-sur-panier",
        ligne_de_liste: "commentaire-sur-article",
      }[this.typeObject];
    },
    /**
     * Route de l'API à utiliser pour enregistrer le commentaire (le panier est une liste).
     * @returns {String} Nom de la route.
     */
    apiRoute() {
      return this.typeObject === "panier" ? "liste" : this.typeObject;
    },
  },
  watch: {
    "value.commentaire": {
      handler() {
        this.comment = this.value.commentaire;
      },
    },
  },
  methods: {
    debounceSaveComment() {
      this.commentSavedState = "pending";

      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.saveComment();
      }, config.api.debounceDelay);
    },
    saveComment() {
      Api()
        .patch(`/${this.apiRoute}/${this.value.id}/`, {
          commentaire: this.comment,
        })
        .then(() => {
          this.commentSavedState = "saved";
        })
        .catch(() => {
          this.commentSavedState = "error";
        });
    },
  },
};
</script>

<style lang="scss">
@use "~@lde/core_lde_vue/dist/assets/styles/_variables.scss" as var;

.commentaire, .product-table tbody .libelle .commentaire {
  margin: var.$space-tiny 0;
  font-size: var.$font-regular;

  label {
    margin-bottom: 0;
    display: block;
  }

  textarea {
    width: 100%;
    min-height: 8rem; // 3 lignes
    padding: var.$space-x-tiny;
    border: 1px solid var.$blue-16;
    border-radius: var.$border-radius-base;
  }

  p {
    font-size: var.$font-base;
    margin: 0;
    text-align: right;
    margin-top: calc(var.$space-xx-tiny * -1);
    margin-right: var.$space-x-tiny;
  }
}
</style>
